import { useForm } from 'libs/form'
import { useTranslation } from 'libs/i18n'
import { routes } from 'config/routes'
import { BackButton, Form, Header } from 'shared/components'
import { useAreaValidationSchema } from 'features/areas/hooks/useAreaValidationSchema'
import { AreaFormSections } from 'features/areas/organisms/AreaForm/AreaFormSections'
import { useAddAreaMutation } from './mutations/useAddAreaMutation'

const AreaAddPage = () => {
	const { t } = useTranslation()
	const validationResolver = useAreaValidationSchema()

	const form = useForm({
		mode: 'onChange',
		resolver: validationResolver
	})
	const { handleSubmit } = form

	const { addAreaMutation, isAddAreaLoading } = useAddAreaMutation()

	const onSubmit = (data: any) => {
		addAreaMutation({
			booth_type: data.boothType.value,
			number: +data.number,
			is_active: data.is_active
		})
	}

	return (
		<>
			<Header
				title={t('Add area')}
				eyebrow={t('Booking engine')}
				actions={<BackButton to={routes.areaIndex} text={t('Back to areas')} />}
			/>
			<div className="px-5 lg:px-0">
				<Form
					variant="sections"
					submitText={t('Create area')}
					onSubmit={handleSubmit(onSubmit)}
					isLoading={isAddAreaLoading}>
					<AreaFormSections form={form} />
				</Form>
			</div>
		</>
	)
}

export default AreaAddPage
